import type { AxiosResponse } from 'axios';

import { RetrieveSuggestedSectionResponse } from '../api/types/searchApiTypes';
import {
  donedealGateway,
  donedealServicesGateway,
} from '../api/api-utils/commonApiUtils';
import { z } from 'zod';

const getCarsCountSchema = z.object({
  paging: z.object({
    totalResults: z.number(),
  }),
});

type GetCarsCountPayload = {
  ranges: {
    from: string | undefined;
    to: string | undefined;
    name: string;
  }[];
  paging: {
    from: number;
    pageSize: number;
  };
  makeModelFilters?: {
    make: string;
    model: string | undefined;
    trim: string | undefined;
  }[];
  sections: string[];
};

async function getCarsCount({
  make,
  model,
  priceFrom,
  priceTo,
  yearFrom,
  yearTo,
}: {
  make: string | undefined;
  model: string | undefined;
  priceFrom: string | undefined;
  priceTo: string | undefined;
  yearFrom: string | undefined;
  yearTo: string | undefined;
}): Promise<number> {
  const payload: GetCarsCountPayload = {
    ranges: [
      ...(priceFrom || priceTo
        ? [
            {
              from: priceFrom,
              to: priceTo,
              name: 'price',
            },
          ]
        : []),
      ...(yearFrom || yearTo
        ? [
            {
              from: yearFrom,
              to: yearTo,
              name: 'year',
            },
          ]
        : []),
    ],
    sections: ['cars'],
    paging: { from: 0, pageSize: 0 },
  };

  if (make) {
    payload.makeModelFilters = [
      {
        make,
        model,
        trim: undefined,
      },
    ];
  }

  const response: AxiosResponse = await donedealServicesGateway.post(
    `/ddapi/v2/search`,
    payload,
  );

  const data = getCarsCountSchema.parse(response.data);

  return data.paging.totalResults;
}

async function getSuggestedSections(
  title: string,
): Promise<AxiosResponse<RetrieveSuggestedSectionResponse[]>> {
  const response: AxiosResponse<RetrieveSuggestedSectionResponse[]> =
    await donedealGateway.post(`/ddapi/v1/search/suggested/sections`, {
      title,
    });
  return response;
}

export const searchApi = {
  getCarsCount,
  getSuggestedSections,
};
